import {Controller} from "@hotwired/stimulus"

/**
 * TurboReconnectingController attaches a listener which reconnects
 * the controller on turbo:render so that any DOM setup done in `connect` is
 * performed again on the new DOM.
 */
export default class extends Controller {
  isControlledElement = false;

  initialize() {
    super.initialize();

    this.beforeMorphtHandler = this._beforeMorph.bind(this);
    this.element.addEventListener('turbo:before-morph-element', this.beforeMorphtHandler);

    this.reconnectHandler = this._reconnect.bind(this);
    document.addEventListener('turbo:render', this.reconnectHandler);
  }

  _beforeMorph(e) {
    if (e.detail.currentElement.dataset?.controller) {
      this.isControlledElement = true;
    }
  }

  _reconnect() {
    if (this.isControlledElement) {
      this.disconnect();
      this.connect();
      this.isControlledElement = false;
    }
  }
}